<template>
	<div :class="['draw-item',{'got': $attrs.drawn}]">
		<Item 
			v-bind="$attrs"
			v-on="$listeners"
			type="draw"
			:class="[{'current-draw':$attrs.currentItemIndex.indexOf($attrs.index)>-1}]"
		></Item>
	</div>
</template>
<script>
import Item from '@/components/item/index.vue'
export default{
	name: "Drawitem",
	data(){
		return{}
	},
	inheritAttrs: false,
	components:{
		Item
	}
}
</script>
<style lang="scss" scoped>
.draw-item{
	@include res-size(
		$margin-bottom: 60px
	)
}
.draw-item.got,.draw-item.gray{
	@include gray
}
</style>


// WEBPACK FOOTER //
// src/components/drawitem/index.vue